import gql from "graphql-tag";

export const EDIT_COUNCIL_PROFILE = gql`
mutation update_council_profile($data: council_profile_set_input, $user_id: uuid!) {
    update_council_profile(where: {user_id: {_eq: $user_id}}, _set: $data) {
      returning {
        id
      }
    }
  }   
`;